export enum Languages {
  EN = 'EN',
  RU = 'RU',
}
